<template>
  <div class="Voice" :class="{ 'share': on_share }"> 
    <Title ref="title" indice="voice"/>
    <Visualisation ref="visualisation" indice="visualisation"/>
    <div class="Voice__visualisation">
      <div ref="txt" class="Voice__txt" v-html="txt"/>
    </div>
    <template v-if="step == 'record'">
      <Description ref="description" indice="voice"/>
      <div class="Bottom">
        <RecordButton ref="record"/>
      </div>
    </template>
    <template v-if="step == 'share'">
      <div class="Voice__bottom">
        <ListenButton ref="listen"/>
        <div class="Voice__share">
          <ShareButton ref="share"/>
        </div>
      </div>
    </template>
    <ExempleButton indice="hear" v-if="!use_exemple && step != 'share'"/>
    <HearComp v-if="use_exemple"/>
  </div> 
</template>

<script>

import gsap from "gsap"
import BackButton from "./assets/BackButton.vue"
import Title from "./assets/Title.vue"
import Visualisation from "./assets/Visualisation.vue"
import LineSegment from "./assets/LineSegment.vue"
import Description from "./assets/Description.vue"
import RecordButton from "./assets/RecordButton.vue"
import ShareButton from "./assets/ShareButton.vue"
import ListenButton from "./assets/ListenButton.vue"
import SoundControl from "./assets/SoundControl.vue"
import ExempleButton from "./assets/ExempleButton.vue"
import HearComp from "./assets/HearComp.vue"

export default {

  name: 'Voice',
  components: { BackButton, Title, Visualisation, Description, RecordButton, ShareButton, ListenButton, SoundControl, LineSegment, ExempleButton, HearComp },
  data: ()=>({
    step: '',
    listen: false,
    on_share: false,
    use_exemple: false,
    txt: ''
  }),

  computed: {
    status() { return this.$store.getters['app/status'] }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        if(this.$root.route.to.params.section == 'record') this.step = 'share'
        else this.step = 'record'
        this.on_share = this.$root.route.to.params.step == 'share' ? true : false
      }
    },

    'step'(nw) {
      this.$nextTick(()=>{
        if(nw == 'record')
          this.addRecordButton()
        else
          this.addShareButton()
      })
    },

    'txt'(nw) {
      // this.$nextTick(()=>{
      //   if(this.$tween)
      //     this.$tween.kill()
      //   this.$tween = gsap.set(this.$refs.txt, { opacity: 0 })
      //   this.$tween = gsap.to(this.$refs.txt, {
      //     duration: .5, 
      //     opacity: 1, 
      //     ease: 'none', 
      //   })
      // })
    },

    status(nw) {
      if(nw == 'audio_ended')
        this.completeListen()
    },

  },

  mounted() { 
    this.$nextTick(()=>{
      this.addRecordButton()
      gsap.from(this.$refs.txt, { duration: .35, opacity: 0, delay: 1, ease: 'none' })
      gsap.from(this.$refs.visualisation.$el, { duration: .35, opacity: 0, delay: .5, ease: 'none' })
    })
  },

  methods:{  

    addRecordButton() {
      gsap.from([ this.$refs.description.$el, this.$refs.record.$el ], {
        duration: .5, 
          y: '+=400%', 
          ease: 'cubic.out', 
          stagger: .2,
          delay: .2, 
      })
    },

    addShareButton() {
      gsap.from([ this.$refs.listen.$el, this.$refs.share.$el ], {
        duration: .5, 
          y: '+=600%', 
          ease: 'cubic.out', 
          stagger: .2,
          delay: .75, 
      })
    },

    onClick() {
      this.$router.push({ params: { section: 'record' } })
    },
    onListen() {
      this.$store.commit('app/UPDATE_STATUS', 'listen_audio')
      this.$store.commit('app/ADD_LISTEN', true)
      // this.txt = "Listening simulation"
      this.txt = ""
      this.listen = true
      // gsap.delayedCall(3, ()=>{ this.completeListen() })
    },
    completeListen() {
      this.$store.commit('app/ADD_LISTEN', false)
      this.txt = ""
      this.listen = false
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Voice
  position absolute
  top 0
  left 0
  color white
  width 100%
  height 100%
  display flex 
  flex-direction column
  justify-content space-between
  align-items center
  transition opacity .35s
  opacity 1

  &.share
    opacity .15

  &__bottom
    width 100%
    height 32%
    display flex
    flex-direction column
    align-items center
    justify-content flex-end

  &__share
    padding 2vh 0 5vh
    width 100%

  &__visualisation 
    width 100%
    height 45%
    position relative
    display flex 
    align-items center
    justify-content center
    color red

  &__txt 
    text-align center
    line-height 24px
    padding-top 48px

</style>


